module.exports = __webpack_public_path__ + "static/media/instruction_hips.8ae6ad88.webp";